import Typography from '@mui/material/Typography';


export default function MtorTextInfo() {
  
  return (
<div>
    
    <Typography variant="h6" >
  
    <Typography component="span" variant="h6" sx={{fontWeight: '700'}}>MTOR variants - polymorphism analysis</Typography>
    <br /><br />
    
    MTOR gene = Mechanistic Target of Rapamycin. The mTOR protein complex is known to be involved in many processes, as a key agent in multiple functions of the body and 
    especially in metabolism. When mTOR activity is just slightly increased, aging set earlier on, and the lifetime of animals can be shortened by up to 20%.


    <br /><br />
    There is a link of mTOR to various processes related to aging, such as nutrient sensing, maintenance of proteostasis, autophagy, mitochondrial dysfunction, cellular senescence, and decline in stem cell function.

    <br /><br />

	TOR as a negative regulator of life span <br />
    mTOR as a regulator of food intake and global energy homeostasis<br />
	mTOR and the beneficiary effects of dietary restriction on life span.<br /><br />



    <Typography component="span" variant="h6" sx={{fontWeight: '700'}}>Actionability: What can you do?</Typography>
    <br /><br />

Dietary modulation: Caloric restriction and low-protein diets inhibit mTOR, promoting autophagy.<br />
Pharmacological interventions: Use of rapamycin or rapalogs to mimic caloric restriction effects.<br />
Monitoring: Biomarkers like mTOR signaling activity in peripheral blood mononuclear cells.

 <br /><br /><br />


Source: 
<Typography component="span" variant="body1" sx={{fontWeight: '200'}}>
    <br /><br />
    https://pmc.ncbi.nlm.nih.gov/articles/PMC6611156/    <br />
</Typography>

    </Typography>
</div>
)}